/* eslint-disable react-hooks/exhaustive-deps */
import {
    useEffect,
    useRef,
} from "react";

import useApiSource from "../../../api/source";
import useApiViaje from "../../../api/operaciones/useApiViajes";
import useApiConfiguracionCajaChica from "../../../api/catalogos/useApiConfiguracionCajaChica";
import useApiSeguimiento from "../../../api/operaciones/useApiViajesSeguimiento";
import useApiLiberacionViaje from "../../../api/administracion/useApiLiberacionViaje";
export default function ProgramacionViajesySeguimientoNuevo() {
    const apiSource =
        useApiSource();

    const apiViajes =
        useApiViaje();

    const apiCajaChica = useApiConfiguracionCajaChica();
    const apiRef =useRef(null);
    const apiSeguimiento= useApiSeguimiento();
    const apiLiberacionViaje = useApiLiberacionViaje();
    apiRef.current = {
        source: apiSource,
        viajes: apiViajes,
        sourceCajaChica:apiCajaChica,
        seguimiento: apiSeguimiento,
        liberacionViaje: apiLiberacionViaje
    };

    useEffect(() => {
        const probarCajaChica =
            async () => {
                try {
                 
                    // const tipos =
                    //     await apiCajaChica
                    //         .filtrarTipoGastos(
                    //             {}
                    //         );

                   

                    // const conceptos =
                    //     await apiCajaChica
                    //         .filtrarConceptos(
                    //             {}
                    //         );

                   
                } catch (error) {
                    console.error(
                        "Error directo de Caja Chica:",
                        error?.response
                            ?.data ??
                            error
                    );
                }
            };

        probarCajaChica();
    }, []);

    useEffect(() => {
        if (
            typeof window
                .mountProgramacionViajes !==
            "function"
        ) {
            console.error(
                "No se encontró window.mountProgramacionViajes."
            );

            return;
        }

        const desmontar =
            window.mountProgramacionViajes(
                "programacionViajesySeguimiento-nuevo",
                {
                    api:
                        apiRef.current,
                }
            );

        return () => {
            if (
                typeof desmontar ===
                "function"
            ) {
                desmontar();
            }
        };    }, []);

    return (
        <div id="programacionViajesySeguimiento-nuevo" />
    );
}